(function (Drupal) {
  'use strict';

  /**
   * Read-more / collapse behavior for Social Media Post captions.
   *
   * Applies to:
   * 1. Layout Builder Social Media Post block captions (.social-media-post-block__caption)
   * 2. WYSIWYG-embedded Social Media (caption-drupal-media wrapping media--type-social-media)
   *
   * Matches existing media caption UX in media.js — truncates with "More" link,
   * expands/collapses on interaction.
   */
  Drupal.behaviors.socialMediaPostCaption = {
    attach: function (context) {
      // 1. WYSIWYG-embedded Social Media with captions
      var wysiwygCaptions = context.querySelectorAll
        ? context.querySelectorAll('.caption-drupal-media:not(.caption--processed) .media--type-social-media')
        : [];

      wysiwygCaptions.forEach(function (mediaEl) {
        var wrapper = mediaEl.closest('.caption-drupal-media');
        if (!wrapper) return;

        // Add class for CSS fallback (mirrors :has() selector)
        wrapper.classList.add('has-social-media');

        // Hide native Instagram caption when a WYSIWYG caption is present
        var igEmbed = wrapper.querySelector('.instagram-media[data-instgrm-captioned]');
        if (igEmbed) {
          igEmbed.removeAttribute('data-instgrm-captioned');
        }

        // Skip read-more if inside .field--name-body — media.js already handles that context.
        if (wrapper.closest('.field--name-body')) {
          wrapper.classList.add('caption--processed');
          return;
        }

        var figcaption = wrapper.querySelector('figcaption');
        if (!figcaption) {
          wrapper.classList.add('caption--processed');
          return;
        }

        initReadMoreFigcaption(wrapper, figcaption);
        wrapper.classList.add('caption--processed');
      });
    }
  };

  /**
   * Initialize read-more for WYSIWYG figcaption elements.
   * Matches the pattern in media.js for consistency.
   * @param {Element} wrapper - The .caption-drupal-media wrapper.
   * @param {Element} figcaption - The figcaption element.
   */
  function initReadMoreFigcaption(wrapper, figcaption) {
    var captionHeight = figcaption.scrollHeight;

    // Only add read-more if caption exceeds single-line height
    if (captionHeight <= 30) return;

    wrapper.classList.add('expandable');
    figcaption.setAttribute('data-height', captionHeight);

    var expandButton = document.createElement('button');
    expandButton.innerHTML = 'More';
    expandButton.addEventListener('click', function () {
      wrapper.classList.toggle('expanded');
      expandButton.innerHTML = wrapper.classList.contains('expanded') ? 'Less' : 'More';
      figcaption.style.height = wrapper.classList.contains('expanded')
        ? (captionHeight + 16) + 'px'
        : '24px';
    });

    figcaption.appendChild(expandButton);
  }

})(Drupal);
